module.exports = __webpack_public_path__ + "static/design_photo-76883a0f33e335cd4b7f3b85de74a016.jpg";